"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MetaSyncController", {
    enumerable: true,
    get: function() {
        return MetaSyncController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _catchError = require("~/helpers/catchError");
const _Jobs = require("~/interface/Jobs");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let MetaSyncController = class MetaSyncController {
    async metaDiffSync(context, baseId, req) {
        const jobs = await this.jobsService.jobList();
        const fnd = jobs.find((j)=>j.name === _Jobs.JobTypes.MetaSync && j.data.baseId === baseId);
        if (fnd) {
            _catchError.NcError.badRequest('Meta sync already in progress for this base');
        }
        const job = await this.jobsService.add(_Jobs.JobTypes.MetaSync, {
            context,
            baseId,
            sourceId: 'all',
            user: req.user,
            req
        });
        return {
            id: job.id
        };
    }
    async baseMetaDiffSync(context, baseId, sourceId, req) {
        const jobs = await this.jobsService.jobList();
        const fnd = jobs.find((j)=>j.name === _Jobs.JobTypes.MetaSync && j.data.baseId === baseId && (j.data.baseId === baseId || j.data.baseId === 'all'));
        if (fnd) {
            _catchError.NcError.badRequest('Meta sync already in progress for this base');
        }
        const job = await this.jobsService.add(_Jobs.JobTypes.MetaSync, {
            context,
            baseId,
            sourceId,
            user: req.user,
            req
        });
        return {
            id: job.id
        };
    }
    async metaDiff(context, baseId, req) {
        const jobs = await this.jobsService.jobList();
        const fnd = jobs.find((j)=>j.name === _Jobs.JobTypes.MetaDiff && j.data.baseId === baseId);
        if (fnd) {
            return {
                id: fnd.id
            };
        }
        const job = await this.jobsService.add(_Jobs.JobTypes.MetaDiff, {
            context,
            baseId,
            sourceId: 'all',
            user: req.user,
            req
        });
        return {
            id: job.id
        };
    }
    async baseMetaDiff(context, baseId, sourceId, req) {
        const jobs = await this.jobsService.jobList();
        const fnd = jobs.find((j)=>j.name === _Jobs.JobTypes.MetaDiff && j.data.baseId === baseId && (j.data.sourceId === sourceId || j.data.sourceId === 'all'));
        if (fnd) {
            return {
                id: fnd.id
            };
        }
        const job = await this.jobsService.add(_Jobs.JobTypes.MetaDiff, {
            context,
            baseId,
            sourceId,
            user: req.user,
            req
        });
        return {
            id: job.id
        };
    }
    constructor(jobsService){
        this.jobsService = jobsService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/meta-diff',
        '/api/v2/meta/bases/:baseId/meta-diff'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('metaDiffSync', {
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], MetaSyncController.prototype, "metaDiffSync", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/meta-diff/:sourceId',
        '/api/v2/meta/bases/:baseId/meta-diff/:sourceId'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('baseMetaDiffSync', {
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('sourceId')),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], MetaSyncController.prototype, "baseMetaDiffSync", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/meta-diff',
        '/api/v2/meta/bases/:baseId/meta-diff'
    ]),
    (0, _extractidsmiddleware.Acl)('metaDiff', {
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], MetaSyncController.prototype, "metaDiff", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/meta-diff/:sourceId',
        '/api/v2/meta/bases/:baseId/meta-diff/:sourceId'
    ]),
    (0, _extractidsmiddleware.Acl)('metaDiff', {
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('sourceId')),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], MetaSyncController.prototype, "baseMetaDiff", null);
MetaSyncController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], MetaSyncController);
